import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChange,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';
import { IChecklist2ReportHistoryCheckpointsCount } from '../../../shared/fi-checklist2-report';
import { isEqual } from '@fi-shared/utils';
import { IReportChartData } from '@fi-app/shared/fi-report-pie-chart/fi-report-pie-chart';

@Component({
    selector: 'fi-checklist-history-deviations-chart',
    templateUrl: './checklist-history-deviations-chart.component.html',
    styleUrls: ['./checklist-history-deviations-chart.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist-history-deviations-chart' },
    standalone: false,
})
export class FiChecklistHistoryDeviationsChart implements OnInit, OnChanges {
    @Input() unitsCheckpointsCount: IChecklist2ReportHistoryCheckpointsCount;
    @Input() isChartInteractive: boolean;
    @Input() isChartSegmentsInteractive: boolean;
    @Output() onChartSegmentClick = new EventEmitter<number>();

    notDeviationsCount: number;
    filledCheckpointsCount: number;

    ngOnInit() {
        this.setCounters();
    }

    ngOnChanges(changes: SimpleChanges) {
        const change: SimpleChange = changes.unitsCheckpointsCount;
        if (change && !isEqual(change.currentValue, change.previousValue)) this.setCounters();
    }

    chartSegmentClick($event: number) {
        this.onChartSegmentClick.emit($event);
    }

    private setCounters() {
        this.filledCheckpointsCount =
            this.unitsCheckpointsCount.notOkCheckpointCount + this.unitsCheckpointsCount.okCheckpointCount;
        this.notDeviationsCount = this.unitsCheckpointsCount.okCheckpointCount;
    }

    getChartData(): IReportChartData[] {
        return [
            {
                gradientColorLight: '#FF6454',
                gradientColorBright: '#DE3730',
                value: this.unitsCheckpointsCount.notOkCheckpointCount,
            },
            {
                gradientColorLight: '#29CC6A',
                gradientColorBright: '#18C45D',
                value: this.notDeviationsCount,
            },
        ];
    }

    getValueLabel(value: number): string {
        const percentageValue: string = `${this.getPercentageValue(value)}%`;
        return `<span class="bold">${percentageValue}</span> (${value}/${this.filledCheckpointsCount})`;
    }

    private getPercentageValue(value: number): number {
        return !this.filledCheckpointsCount ? 0 : Math.round((100 * value) / this.filledCheckpointsCount);
    }

    getChartMainValue() {
        return `${this.getPercentageValue(this.filledCheckpointsCount - this.notDeviationsCount)}%`;
    }
}
